// src/util/session_check.js
import logout from '@/util/logout';
import { SessionStorage } from '@/storage';

// 必需的 SessionStorage 鍵值
const REQUIRED_SESSION_STORAGE_KEYS = [
  'site_list',
  'game_kind_list',
  'game_brand_list'
];

/**
 * 檢查 SessionStorage 中的關鍵資料是否完整
 * @param {boolean} show_warning - 是否顯示警告訊息
 * @returns {boolean} - 資料完整返回 true，否則返回 false
 */
export function validate_session_data(show_warning = true) {
  const missing_data = [];

  // 只檢查 SessionStorage 中的關鍵資料
  for (const key of REQUIRED_SESSION_STORAGE_KEYS) {
    const value = SessionStorage.getItem(key);
    if (!value || value === 'null' || value === 'undefined') {
      missing_data.push(`SessionStorage.${key}`);
    }
  }

  // 如果有缺失資料
  if (missing_data.length > 0) {
    if (show_warning) {
      // console.warn('⚠️ SessionStorage 資料缺失:', missing_data);
      // console.warn('🔄 即將重新導向至登入頁面...');
    }
    return false;
  }

  return true;
}

/**
 * 檢查 SessionStorage 並在資料缺失時自動登出
 * @param {string} source - 觸發檢查的來源位置（用於偵錯）
 */
export function check_session_and_logout(source = 'Unknown') {
  if (!validate_session_data()) {
    logout(`SessionStorage 資料缺失 (${source})`);
  }
}
